import './google-location.scss';
import React, { useEffect } from 'react';
// actions & helper
import { noop, getAddressFromPlaces } from '../../utils/helper';
// components
import { Form } from 'react-final-form';
import GoogleAutoComplete from '../GoogleAutoComplete/GoogleAutoComplete';

const defaultMapoptions = { zoom: 12, streetViewControl: false, mapTypeControl: false, fullscreenControl: false };
const mutatorsObj = { setFormattedAddress: (args, state, utils) => utils.changeValue(state, 'address', () => args[0]) };
let map, marker, dragEventListner, mutators, addressDetails; // eslint-disable-line

function GoogleLocation(props) {

    const addMarker = center => {
        return new window.google.maps.Marker({
            position: center,
            map,
            draggable: true
        });
    };

    const updateMarkerPos = address => {
        const location = new window.google.maps.LatLng(address.lat, address.lng);
        marker.setPosition(location);
        // map.panTo(location);
        map.setCenter(location);
    };

    const onChangeMarker = evt => {
        const geocoder = new window.google.maps.Geocoder();
        const location = { lat: evt.latLng.lat(), lng: evt.latLng.lng() };
        geocoder.geocode({ location }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                addressDetails = getAddressFromPlaces(results[0]);
                mutators.setFormattedAddress(addressDetails.address || addressDetails.formattedAddress);
                props.onChangeAddress({ ...addressDetails, ...location });
            } else {
                alert('Cannot determine address at this location.' + status);
            }
        });
    };

    const initMap = ({ lat, lng }) => {
        const $map = document.getElementById('map');
        if (typeof window.google !== 'undefined' && window.google.maps && $map !== null) {
            const mapOptions = { center: new window.google.maps.LatLng(lat, lng), mapTypeId: window.google.maps.MapTypeId.ROADMAP, ...defaultMapoptions };
            map = new window.google.maps.Map($map, mapOptions);
            marker = addMarker({ lat, lng });
            dragEventListner = marker.addListener('dragend', onChangeMarker);
        } else {
            setTimeout(() => { initMap({ lat, lng }); }, 500);
        }
    };

    const onChangeAddress = address => {
        updateMarkerPos(address);
        props.onChangeAddress(address);
    };

    const clearInput = () => mutators.setFormattedAddress('');

    useEffect(() => {
        const center = props.center || { lat: 28.7041, lng: 77.1025 };
        initMap(center);
        return () => {
            window.google.maps.event.removeListener(dragEventListner);
            if (typeof map.clear !== 'undefined') map.clear();
        };
    }, []);

    useEffect(() => {
        if (props.center) {
            if (typeof map !== 'undefined') updateMarkerPos(props.center);
            else setTimeout(() => updateMarkerPos(props.center), 1000);
        }
    }, [props.center]);

    return (
        <div className="google-location-map">
            <Form
                initialValues={{ address: props.address }}
                mutators={mutatorsObj}
                onSubmit={noop}
            >
                {({ handleSubmit, form }) => {
                    mutators = form.mutators;
                    return (
                        <form onSubmit={handleSubmit}>
                            <GoogleAutoComplete name="address" customValidate={noop} fillInAddress={onChangeAddress} mutators={form.mutators} customClass="hto-google-address google-location-address" customInputClass="form-control" placeholder="Search Nearby Location">
                                <span className="clear-input" onClick={() => clearInput()}>x</span>
                            </GoogleAutoComplete>
                        </form>
                    );
                }}
            </Form>
            <div className="location-map" id="map"></div>
        </div>
    );
}

export default GoogleLocation;
